"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Switch = exports.Underlay = exports.Knob = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var KnobPositionStyles = {
  small: (0, _styledComponents.css)(["transform:translateX(12px);"]),
  medium: (0, _styledComponents.css)(["transform:translate(16px,0);"]),
  large: (0, _styledComponents.css)(["transform:translate(20px);"])
};
var KnobSizeStyles = {
  small: (0, _styledComponents.css)(["height:12px;width:12px;&::after{height:13px;}"]),
  medium: (0, _styledComponents.css)(["height:16px;width:16px;&::after{height:17px;}"]),
  large: (0, _styledComponents.css)(["height:20px;width:20px;&::after{height:21px;}"])
};
var UnderlaySizeStyles = {
  small: (0, _styledComponents.css)(["height:", ";width:28px;"], _stylers["default"].spacer(2)),
  medium: (0, _styledComponents.css)(["height:", ";width:36px;"], _stylers["default"].spacer(2.5)),
  large: (0, _styledComponents.css)(["height:", ";width:44px;"], _stylers["default"].spacer(3))
};

var Knob = _styledComponents["default"].span.withConfig({
  displayName: "Switchstyles__Knob",
  componentId: "sc-8dk60q-0"
})(["background-color:", ";border-radius:100%;box-shadow:0 1px 3px rgba(0,0,0,0.4);display:inline-block;left:2px;position:absolute;top:2px;transition:transform 0.25s ease;"], _tokens["default"].color.white);

exports.Knob = Knob;

var Underlay = _styledComponents["default"].span.withConfig({
  displayName: "Switchstyles__Underlay",
  componentId: "sc-8dk60q-1"
})(["background-color:", ";border-radius:50px;display:inline-block;position:absolute;transition:0.25s ease-in-out;user-select:none;vertical-align:middle;"], _tokens["default"].color.blackLighten50);

exports.Underlay = Underlay;
var disabledStyles = (0, _styledComponents.css)(["", "{box-shadow:none;}", "{box-shadow:none;&::after{content:\"\";display:block;left:50%;position:absolute;width:2px;transform:rotate(45deg) translateX(-50%);}}&[aria-checked=\"true\"]{", ",", "::after{background-color:", ";}}&[aria-checked=\"false\"]{", ",", "::after{background-color:", ";}}"], Underlay, Knob, Underlay, Knob, _tokens["default"].color.greenLighten30, Underlay, Knob, _tokens["default"].color.blackLighten60);
var Switch = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Switchstyles__Switch",
  componentId: "sc-8dk60q-2"
})(function (_ref) {
  var size = _ref.size,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["position:relative;&,*{box-sizing:border-box;}", " ", "{", "}", "{", "}&:focus{box-shadow:none;", "{box-shadow:", ";}}&[aria-checked=\"true\"]{", "{background-color:", ";}", "{", "}}", ""], UnderlaySizeStyles[size], Underlay, UnderlaySizeStyles[size], Knob, KnobSizeStyles[size], Underlay, _tokens["default"].highlight.active.withBorder.boxShadow, Underlay, _tokens["default"].color.green, Knob, KnobPositionStyles[size], isDisabled ? disabledStyles : null);
});
exports.Switch = Switch;
//# sourceMappingURL=Switch.styles.js.map